var Modals = (function () {

  Acr = window.Acr ? window.Acr : {};
  var Utility = window.Utility || {};
  var Constants = window.Constants || {};
  var HorizontalSlider = window.HorizontalSlider || {};
  const modalBodySelectorClass = '.modal-body';


  var type = 'fullscreen';
  var subtype = '';
  var media = 'video';
  var title = '';
  var hideHeader = false;
  var content = '';
  var loading = false;
  var callbacks = {};
  var isVisible = false;
  var bapNavItem;
  var doScrolling = true;
  var options = {};
  var modalNavigation = {
    collection: null,
    configuration: null,
  };
  var subtypes = {
    brochure: 'brochure',
  };
  var isModalOpened = false;
  var api;
  var interval;
  var debounceResize = $.noop;
  var scrollPosition = 0;
  var autoplay = (window.innerWidth < 550) ? 0 : 1;
  var isRaqModal = false;

  var $modal = $('.modal');
  var $modalBody = $modal.find(modalBodySelectorClass);
  var $modalDialog = $modal.find('.modal-dialog');
  var $modalHeader = $modal.find('.modal-header');
  var $modalTitle = $modalHeader.find('.modal-title');
  var $modalContent = $modal.find('.modal-content');
  var $closeButton = $('.acr-modal-close');
  var $trigger = $('m');



  document.addEventListener('keydown', function (e) {
    const zipgateElement = document && document.querySelector(modalBodySelectorClass);

    if (zipgateElement) {
      const focusableElements = 'js-zipgate-close, button:not([style*="display: none"]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const firstFocusableElement = zipgateElement.querySelector(focusableElements); // get first element to be focused inside modal
      const focusableContent = zipgateElement.querySelectorAll(focusableElements);
      const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
      const preFocusableElement = focusableContent[focusableContent.length - 2];
      var activeElementClass = document.activeElement.getAttribute('class');
      var currentElement = zipgateElement.getElementsByClassName(activeElementClass);
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      let isIE = Utility.isIE11();

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey && !isIE) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          if (lastFocusableElement !== null && lastFocusableElement.getAttribute('disabled') !== null) {
            preFocusableElement.focus(); // add focus for the last focusable element
            e.preventDefault();
          } else {
            lastFocusableElement.focus();
            e.preventDefault();
          }

        }
      } if (!e.shiftKey && !isIE) {
        if (document.activeElement === lastFocusableElement
        || (!currentElement.length !== 0 && currentElement[0] === document.activeElement && document.getElementsByClassName('js-zipgate show').length > 0)) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          e.preventDefault();
        } else if (lastFocusableElement !== null && document.activeElement === preFocusableElement) {
          if (lastFocusableElement.getAttribute('disabled') !== null) {
            firstFocusableElement.focus(); // add focus for the first focusable element
            e.preventDefault();
          }
        }
      }
    }
  });

  Utility.log('Modals.js loaded');

  function show(event) {
    var button = $(event.relatedTarget);
    var videoID = button.data('videoId');

    $modalDialog.removeClass('modal-loading')
      .removeClass('modal-fullscreen')
      .removeClass('modal-large')
      .removeClass('modal-alert');

    $modal.removeClass('modal-loading')
      .removeClass('modal-fullscreen')
      .removeClass('modal-large')
      .removeClass('modal-alert');

    if (videoID) {
      $modalDialog.addClass('video-modal');
      var player = new Acr.YouTubeManager.YouTubePlayerObject(videoID, $closeButton,
        $modalBody, $modalBody, autoplay);
      player.init();
    }

    if (button.data('videoTracking')) {
      $($modalBody).attr('data-video-tracking', button.data().videoTracking);
    }

    if (Acr.TrackingManager) {
      Acr.TrackingManager.savePageLoadObject();
    }
    scrollPosition = $('html').scrollTop() || window.pageYOffset;
    $('body').css({
      position: 'fixed',
      'margin-top': '-' + scrollPosition + 'px',
    });
  }

  function shown(event) { }

  function hide(event) {
    $('body').removeAttr('style');
    window.scrollBy(0, scrollPosition);
    clearInterval(window.percentageInterval);
    if (window.setVideoPercentages) { window.setVideoPercentages(); }
    if (Acr.TrackingManager) {
      if (isRaqModal) {
        var closeRaqEvent = Utility.createEvent('closeRaq');
        window.dispatchEvent(closeRaqEvent);
      }

      Acr.TrackingManager.restorePageLoadObject();
    }
  }

  function loaded(event) { }

  function hidden() {
    $('.modal-body').html('');
    $(window).trigger('ar.closemodal');

    isModalOpened = false;
  }

  function fireClickEvent(event) {
    var $this = $(event.currentTarget);
    var cookieZipcode = Utility.getCookie('zipcode');

    isRaqModal = $this.data('raq');


    if (event.preventDefault) {
      event.preventDefault();
    }

    // Deleting sessionStorage bapAccessories
    if (!window.BaP) {
      sessionStorage.removeItem('bapAccessories');
    }

    if ($this.data('modal-video-id')) {
      if ($this.data('videoTracking')) {
        $($modal).find('.modal-body').attr('data-video-tracking', $this.data('videoTracking'));
      }

      Modals.trigger(
        ($this.data('modal-title')) ? $this.data('modal-title') : 'Acura',
        $this.data('modal-content'),
        $this.data('modal-type') ? $this.data('modal-type') : 'large',
        'video',
        {
          hideHeader: $this.data('modal-hide-header'),
          bapNavItem: $this.data('modal-bap-nav-item'),
          url: $this.attr('href'),
          navigation: $this.data('modal-navigation')
            ? $.parseJSON($this.data('modal-navigation')
              .replace(/&#34;/g, '"'))
            : null,
          videoId: $this.data('modal-video-id'),
          videoSource: $this.data('modal-video-source'),
        },
        $this.data('modalbap'),
        isRaqModal,
      );
    } else if (isRaqModal && !cookieZipcode) {
      if (Acr.zipgateComponent) {
        type = 'large';

        Acr.zipgateComponent.openZipgate(fireClickEvent, event, true);
      }
    } else {
      // if it's not a video modal then check modal-type attribute
      //  if modal-type is not set then default to large
      //  otherwise use data-attr value
      type = ($this.data('modal-type') && $this.data('modal-type').length > 0) ? 'large' : $this.data('modal-content');
      subtype = $this.data('modal-subtype');

      Modals.trigger(
        ($this.data('modal-title')) ? $this.data('modal-title') : 'Acura',
        $this.data('modal-content'),
        $this.data('modal-type'),
        '', // Content is empty, so it will be loaded from url.
        {
          hideHeader: $this.data('modal-hide-header'),
          bapNavItem: $this.data('modal-bap-nav-item'),
          url: $this.attr('href'),
          navigation: $this.data('modal-navigation')
            ? $.parseJSON($this.data('modal-navigation')
              .replace(/&#34;/g, '"'))
            : null,
        },
        $this.data('modalbap'),
        isRaqModal,
      );
    }

    var modalType = Modals.getType();
    var modalSubType = Modals.getSubType();
    var modalTypeClass = modalType && 'modal-' + modalType;
    var modalSubTypeClass = modalSubType && 'modal-' + modalSubType;

    // set the classes on the modal elements so our CSS can work its magic
    $modal.removeClass('modal-large modal-fullscreen modal-alert');
    if (!$this.data('modal-video-id')) {
      $modal.addClass(modalTypeClass);
    }
    if (modalSubType) {
      $modal.addClass(modalSubTypeClass);
    }

    $modalDialog.removeClass('modal-large modal-fullscreen modal-alert');
    if (modalType !== 'large') {
      if ($this.data('modal-video-id') && modalType !== 'fullscreen') {
        $modalDialog.addClass(modalTypeClass);
      }
    }
    return false;
  }

  function wireLinks() {
    $(document).on('click', '[data-modal-video-id], [data-modal-type]', function (e) {
      e.preventDefault();

      fireClickEvent(e);
    });

    $(document).on('activateModal', function (e, param) {
      e.preventDefault();

      fireClickEvent(param);
    });

    return Modals;
  }

  function showData() {
    Modals.setLoading(false);

    $modal.removeClass('modal-loading');

    if (Modals.getHideHeader()) {
      $modalHeader.hide();

      $('.modal-no-header-close').show();
    }

    $modalTitle.html(Modals.getTitle());

    if (Modals.getMedia() === 'video') {
      var options = Modals.getOptions();

      if (options.videoId) {
        $modalDialog.addClass('video-modal');
        var player = new Acr.YouTubeManager.YouTubePlayerObject(options.videoId, $closeButton,
          $modalBody, $modalBody, autoplay);
        player.init();
      }
      $modalBody.show();
    } else {
      $modalBody.html(Modals.getContent());

      ImageFix($modalBody);

      if (Modals.getModalNavigation().collection) {
        configNavigation();
      }
    }

    // Calling callbacks
    Object.keys(Modals.getCallbacks()).forEach(function (k) {
      Modals.getCallbacks()[k].apply();
    });

    $modalBody.animate({
      scrollTop: 0,
    }, 'fast');
  }

  // This function shows the modal body and calculates the description container height
  function showModalBody() {
    $modalContent.css('display', 'none');
    $modalBody.show(function () {
      var windowHeight = document.body.getBoundingClientRect().height;
      var modalHeader = $modalBody.find('.header');
      var windowWidth = $(window).width();
      var headerHeight = 0;
      var imgHeight = $modalBody.find('img').height();
      var $content = $modalBody.find('.content');
      var modalPadding = 100; // Modal should have 50px of padding-top and 50px of padding-bottom

      $modalContent.css({ opacity: 0, display: 'block' });
      if (modalHeader) {
        headerHeight = modalHeader.height();
      }

      if (windowWidth < Constants.breakpoints.sm || subtype) {
        imgHeight = $modalBody.find('img').height();
        $content.innerHeight(windowHeight - headerHeight - imgHeight - modalPadding);
      } else {

        $content.innerHeight('auto');
        imgHeight = $modalBody.find('img').height();

        if (imgHeight > 0 && $content.height() > imgHeight * 1.2) {
          $content.height(imgHeight * 1.2);
        }
      }

      isModalOpened = true;
      $modalContent.css('opacity', 1);
    });

    // Init LazyLoading
    Acr.LazyLoadingHelper.init();
    Acr.Disclaimer.init();

    // If brochure modal
    if (subtype && subtype === subtypes.brochure) {
      RequestBrochure.init();
      Validation.init();
    }
  }

  function ImageFix($modalBody) {
    // Correct image src from picture srcset for IE
    var bpCurrent = getCurrentBreakpoint();
    var $pictures = $('picture', $modalBody);

    if ($pictures.length > 0) {
      $pictures.each(function (i, el) {
        var src;
        var srcset;
        var newSrc;
        var breakPImages;
        var image = new Image();

        switch (bpCurrent) {
          case 'sm': breakPImages = $(el).find('source[media|="(min-width: 550px)"]');
            break;
          case 'lg': breakPImages = $(el).find('source[media|="(min-width: 1024px)"]');
            break;
          case 'xl': breakPImages = $(el).find('source[media|="(min-width: 1400px)"]');
            break;
          default: breakPImages = $(el).find('img');
            break;
        }


        srcset = breakPImages.attr('srcset') || breakPImages.attr('data-srcset');
        if (srcset !== undefined) {
          src = breakPImages.attr('src') || breakPImages.attr('data-src');
          newSrc = srcset ? srcset.split(',') : src.split(',');
          newSrc = newSrc[0];
          $(el).find('img').attr('src', newSrc);
          showModalBody();

          image.onload = function () {
            // Needs improvement here.  We're showing the modal once the first
            // image is loaded, but in all cases so far, there's only one
            // picture element in the (feature) modal.
            showModalBody();
          };

          image.src = newSrc;

        } else {
          showModalBody();
        }
      });
    } else {
      showModalBody();
    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  function trigger(title, content, type, media, options, isBap, isRaq) {
    Utility.log('Triggering Modal...');

    if (title === 'undefined' || title === '' || title === null) {

      $.each(options.navigation, function (index, obj) {
        $.each(obj, function (index, option) {
          if (option.selected) {
            title = option.title;
          }
        });
      });
    }

    isVisible = true;

    if (!options) {
      options = {};
    }

    $modal
      .removeClass('modal-fullscreen')
      .removeClass('modal-large')
      .removeClass('modal-video')
      .removeClass('modal-raq')
      .removeClass('modal-alert');

    $modalBody.removeClass('modal-with-navigation');

    Modals
      .setTitle(title)
      .setHideHeader(options.hideHeader && options.hideHeader === true)
      .setContent(content || '')
      .setType(type)
      .setMedia(media)
      .setBapNavItem(options.bapNavItem)
      .setLoading(true)
      .setOptions(options)
      .setModalNavigation('collection', options.navigation);

    $modalHeader.show();

    $('.modal-footer').hide();

    $('.modal-no-header-close').hide();

    var opts = {};

    if (options.modalClass) {
      $modal.addClass(options.modalClass);
    }

    if (Modals.getType() === 'alert' || Modals.getType() === 'zipgate') {
      opts = {
        backdrop: 'static',
        keyboard: false,
      };
    }

    $modal.attr('data-keyboard', 'false'); // IE fix to turn off ESC key

    $modal.modal(opts);

    $modal.addClass('modal-loading');

    if (isRaq) {
      $modal.addClass('modal-raq modal-large');
    }

    if (Modals.getType() === 'zipgate') {
      $modal.addClass('modal-zipgate');
    }

    $modalBody
      .html('')
      .hide();

    $modalTitle.html('');

    $modalHeader.removeClass('modal-alert');

    $('.modal-title-info').html('');

    if (Modals.getContent() === '' && Modals.getMedia() !== 'video') {
      var hash = null;

      var URLArray = options.url.split('#');

      if (URLArray.length > 1) {
        options.url = URLArray[0];
        hash = URLArray[1];
      }

      var URL = options.url + (options.url.indexOf('?') === -1 ? '?' : '&')
        + 'stub=1';

      $.get(URL, function (data) {
        Modals
          .setContent(data)
          .addCallback(function () {
            if ($modal.hasClass('modal-raq')) {
              window.RaqTool.initRaq('.modal-body');
              window.RaqTool.initDealerInfo();
            }

            if (hash !== null) {
              window.location.hash = '';
              window.location.hash = hash;
              if ($('.modal .rzf-gry').length > 0 && window.RZF) {
                window.RZF.runAll.init();
              }
            }
          });

        showData();
        // Fix HRT 7576
        if (isBap) {
          HorizontalSlider.init();
        }
      });
    } else {
      showData();
    }

    if ($modal.find('.acr-gallery.black').length > 0) {
      $modal.addClass('black');
    } else {
      $modal.removeClass('black');
    }

    if ($(window).width() <= 549) {
      window.cosito = $modal;
      if (type === 'large' || media === 'video') {
        $modal.find('.responsive-table-header-mobile').css({ display: 'none' });
        $('.responsive-table-title-accordion.active.docked.cloned')
          .prev('.responsive-table-header-mobile').remove();

        $('.responsive-table-title-accordion.active.docked.cloned').remove();
      } else if (type === 'fullscreen') {
        $modal.find('.responsive-table-header-mobile').css({ display: 'block' });

        $('.responsive-table-title-accordion.active.docked.cloned')
          .prev('.responsive-table-header-mobile').remove();

        $('.responsive-table-title-accordion.active.docked.cloned').remove();
      }
    }
  }

  function launchErrorAlert(title, description) {
    Modals
      .setContent('<html></html>')
      .addCallback(function () {
        $('.modal .modal-alert .close').show();
      });

    Modals.trigger(
      title || ' ',
      description || ' ',
      'alert',
    );
  }

  function setType(t) {
    type = t;

    return Modals;
  }

  function getType() {
    return type;
  }

  function getSubType() {
    return subtype;
  }

  function setMedia(m) {
    media = m;

    return Modals;
  }

  function getMedia() {
    return media;
  }

  function setTitle(t) {
    title = t;

    return Modals;
  }

  function getTitle() {
    return title;
  }

  function setOptions(t) {
    options = t;

    return Modals;
  }

  function getOptions() {
    return options;
  }

  function setHideHeader(hh) {
    hideHeader = hh;

    return Modals;
  }

  function getHideHeader() {
    return hideHeader;
  }

  function setContent(c) {
    content = c;

    return Modals;
  }

  function getContent() {
    return content;
  }

  function setLoading(l) {
    loading = l;

    return Modals;
  }

  function getLoading() {
    return loading;
  }

  function addCallback(cb) {
    callbacks[cb.toString()] = cb;

    return Modals;
  }

  function getCallbacks() {
    return callbacks;
  }

  function setBapNavItem(b) {
    bapNavItem = b;

    return Modals;
  }

  function getBapNavItem() {
    return bapNavItem;
  }

  function setDoScrolling(s) {
    doScrolling = s;
  }

  function getDoScrolling() {
    return doScrolling;
  }

  function setModalNavigation(i, mn) {
    modalNavigation[i] = mn;
  }

  function getModalNavigation() {
    return modalNavigation;
  }

  function navigate(to) {
    var collection = Modals.getModalNavigation().collection;

    var configuration = Modals.getModalNavigation().configuration;

    collection[configuration[to].label][configuration[to].index]
      .selected = true;

    var URL = configuration[to].link
      + (configuration[to].link.indexOf('?') === -1 ? '?' : '&')
      + 'stub=1';

    var speed = 500;

    // URL = '/pages/bp-details-view-non-accessories-stacked-content.html';
    // URL = '/pages/bp-details-view-accessory-modal-2.html';

    $modalBody.append($('<div class="modal-loading-transition"></div>'));

    $modalBody.find('.modal-loading-transition')
      .delay(speed)
      .animate({
        opacity: 1,
      });

    $.get(URL, function (data) {

      $modalBody.append($(data));

      var $slides = {
        leaving: $modalBody.find('.buildPriceDetailsView:eq(0)'),
        coming: $modalBody.find('.buildPriceDetailsView:eq(1)'),
      };

      $modalBody.find('.modal-loading-transition').remove();

      $modalTitle.animate({
        opacity: 0,
      }, speed / 2, function () {
        Modals
          .setTitle(configuration[to].title);

        $modalTitle
          .html(Modals.getTitle())
          .animate({
            opacity: 1,
          }, speed / 2);
      });

      $slides.coming.css({
        left: (to === 'next' ? '' : '-') + '100%',
        right: (to === 'next' ? '-' : '') + '100%',
        opacity: 0,
      });

      $slides.leaving.animate({
        left: (to === 'next' ? '-' : '') + '85%',
        right: (to === 'next' ? '' : '-') + '85%',
        opacity: 0,
      }, {
        duration: speed,
        queue: false,
      });

      $slides.coming.animate({
        left: 0,
        right: 0,
        opacity: 1,
      }, speed, function () {
        $slides.leaving.remove();

        configNavigation();

        $modalBody.children().not($('.buildPriceDetailsView:last')).remove();
      });
    });
  }

  function handleScrolling() {
    $(document).on('touchmove', function (e) {
      if (!Modals.getDoScrolling()) {
        e.preventDefault();
      } else {
        return true;
      }
    });

    $('body').on('touchmove',
      '.modal-body, .disclaimers-content p', function (e) {
        if (!Modals.getDoScrolling()) {
          e.stopPropagation();
        } else {
          return true;
        }
      });
  }

  function resize() {
    if (isModalOpened && Modals.getType() === 'large') {
      showModalBody();
    }

    if (api) {
      api.reinitialise();
    }
  }

  function resizeCallback() {
    clearTimeout(debounceResize);

    debounceResize = setTimeout(resize, 700);
  }

  function onResize() {
    $(window).on('resize', resizeCallback);
  }

  function prepareNavigationsModals() {
    // add the support of pagination like modal
    var dfd = $.Deferred();
    var navigationRequest = [];

    $('[data-modal-service-url]').each(function () {
      var $this = $(this);
      var serviceUrl = $this.data('modal-service-url');
      var deeplink = $this.data('modal-deep-link') || $this.attr('href');
      var endpointUrl = serviceUrl + '?currenturl=' + deeplink;

      var request = $.ajax({
        url: endpointUrl,
        success: function (response) {
          response = { '': response };
          $this.attr('data-modal-navigation',
            JSON.stringify(response).replace(/"/g, '&#34;'));
        },
      });

      navigationRequest.push(request);
    });

    $.when.apply(undefined, navigationRequest)
      .then(function () {
        dfd.resolve();
      });
    return dfd;
  }

  function init() {
    $('.acr-modal').on('show.bs.modal', show);
    $('.acr-modal').on('shown.bs.modal', shown);
    $('.acr-modal').on('hide.bs.modal', hide);
    $('.acr-modal').on('hidden.bs.modal', hidden);
    $('.acr-modal').on('hidden.bs.loaded', loaded);

    try {
      prepareNavigationsModals()
        .done(wireLinks);
    } catch (e) {
      Utility.error(e);
    }

    handleScrolling();

    onResize();

    return Modals;
  }

  return {
    init: init,
    hide: hide,
    trigger: trigger,
    setType: setType,
    getType: getType,
    getSubType: getSubType,
    setMedia: setMedia,
    getMedia: getMedia,
    setOptions: setOptions,
    getOptions: getOptions,
    setTitle: setTitle,
    getTitle: getTitle,
    setHideHeader: setHideHeader,
    getHideHeader: getHideHeader,
    setContent: setContent,
    getContent: getContent,
    setLoading: setLoading,
    getLoading: getLoading,
    addCallback: addCallback,
    getCallbacks: getCallbacks,
    getBapNavItem: getBapNavItem,
    setBapNavItem: setBapNavItem,
    isVisible: function () {
      return isVisible;
    },
    setDoScrolling: setDoScrolling,
    getDoScrolling: getDoScrolling,
    setModalNavigation: setModalNavigation,
    getModalNavigation: getModalNavigation,
    navigate: navigate,
    launchErrorAlert: launchErrorAlert,
  };
}());
